// /assets/scripts/dictionary/pjax/_config.js
export const pjaxConfig = {
	// ルートや差し込み先
	container:     '#MainContent',
	innerSelector: '.page_content_inner',
	
	// UI
	backSelector:  '.js-back',
	blockSelector: 'div[data-page]',
	
	// ルーティング
	topUrl:        '/',
	
	// PJAX 対象リンク
	linkSelectors: [
		'#MainContent a',
		'header#global_header nav li a',
		'a.js-pjax',
		'footer .footer_nav ul li a',
		'#global_header h1 a'
	],
	
	// 除外セレクタ
	ignoreSelectors: [
		'.no-pjax',
		'[data-no-pjax="true"]',
		'[data-pjax="false"]',
		'a[rel~="external"]',
		'variant-selects a',
		'variant-selects [role="option"]',
		'[data-variant-link]',
		'product-info a[data-update-url="true"]'
	],
	
	// レスポンシブでの「最大重なり枚数」
	breakpoints: { xl: 1728, md: 960 },
	maxBlocks:   { xl: 7, md: 4, sm: 3 } // <960 は sm
};

// 画面幅に応じた最大枚数を算出する純関数（テストもしやすい）
export function computeMaxBlocks(width = window.innerWidth, cfg = pjaxConfig) {
	const { xl, md } = cfg.breakpoints;
	const { xl: XL, md: MD, sm: SM } = cfg.maxBlocks;
	if (width >= xl) return XL;
	if (width >= md) return MD;
	return SM;
}